export const PATH_LOGIN_FORM = "/login";
export const PATH_TERMS_OF_SERVICE = "https://www.cjp.nl/algemene-voorwaarden";
export const PATH_PRIVACY_POLICY = "https://www.cjp.nl/privacy";

export default {
  PATH_LOGIN_FORM,
};
